{
  "es": {
    "toast": {
      "action": {
        "email_address_taken": "Esta dirección de correo ya pertenece a otro contacto.",
        "failed": "La acción ha fallado",
        "impersonate_unauthorized": "Esta acción no está permitida mientras se suplanta a un cliente.",
        "storage_quota_exceeded": "Se ha alcanzado el límite de almacenamiento. Elimina archivos o contáctanos para ampliar tu plan.",
        "succeeded": "Acción realizada correctamente",
        "task_assignment_document_required": "Esta tarea necesita al menos un documento antes de poder completarse.",
        "unprocessable": "Algo salió mal, prueba a actualizar la página. Si el problema persiste, contáctanos. \nERROR: {error}"
      },
      "create": {
        "failed": "No se pudo crear {itemName}",
        "succeeded": "{itemName} creado"
      },
      "delete": {
        "failed": "No se pudo eliminar {itemName}",
        "succeeded": "{itemName} se ha eliminado",
        "succeeded_default": "Eliminación realizada correctamente"
      },
      "support_chat": {
        "unavailable": "El chat no está disponible aquí. Escríbenos a {email_address} y te ayudaremos."
      },
      "update": {
        "failed": "No se pudo actualizar {itemName}",
        "succeeded": "{itemName} se ha actualizado",
        "successfully_saved": "Guardado correctamente"
      },
      "upload": {
        "failed": "Error al subir",
        "succeeded": "Subida realizada correctamente"
      },
      "upload_document": {
        "extension_invalid": "El documento «{document_name}» no tiene una extensión válida."
      },
      "upload_image": {
        "file_too_big": "Archivo demasiado grande: el tamaño máximo es 5MB"
      },
      "warning": {
        "multipleFiles": "Esta exportación contiene varios archivos zip. Tu navegador puede bloquear varias descargas. Contacta con el soporte de Ziggu si solo has descargado 1 archivo zip."
      }
    }
  }
}
